"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrappersVisitor = void 0;
const ast_1 = require("@wapc/widl/ast");
const helpers_1 = require("./helpers");
const utils_1 = require("../utils");
class WrappersVisitor extends ast_1.BaseVisitor {
    constructor(writer) {
        super(writer);
    }
    visitOperation(context) {
        if (!utils_1.shouldIncludeHandler(context)) {
            return;
        }
        const operation = context.operation;
        this.write(`var ${operation.name.value}Handler: (${helpers_1.mapArgs(operation.parameters)}) => `);
        if (helpers_1.isVoid(operation.type)) {
            this.write(`Error | null;\n`);
        }
        else {
            this.write(`Result<${helpers_1.expandType(operation.type, true, helpers_1.isReference(operation.annotations))}>;\n`);
        }
        this
            .write(`function ${operation.name.value}Wrapper(payload: ArrayBuffer): Result<ArrayBuffer> {
      const decoder = new Decoder(payload)\n`);
        if (operation.isUnary()) {
            const unaryParam = operation.parameters[0];
            if (helpers_1.isObject(unaryParam.type)) {
                this.write(`const request = new ${helpers_1.expandType(operation.unaryOp().type, false, helpers_1.isReference(operation.annotations))}();
      request.decode(decoder);\n`);
                this.write(helpers_1.isVoid(operation.type) ? "" : "const result = ");
                this.write(`${operation.name.value}Handler(request);\n`);
            }
            else {
                this.write(`const ${helpers_1.read("val", unaryParam.type, false, false)}`);
                this.write(helpers_1.isVoid(operation.type) ? "" : "const result = ");
                this.write(`${operation.name.value}Handler(val);\n`);
            }
        }
        else {
            if (operation.parameters.length > 0) {
                this.write(`const inputArgs = new ${helpers_1.capitalize(operation.name.value)}Args();
        inputArgs.decode(decoder);
        if (decoder.error()) {
          return Result.error<ArrayBuffer>(decoder.error()!)
        }\n`);
            }
            this.write(`const result = ${operation.name.value}Handler(${helpers_1.varAccessArg("inputArgs", operation.parameters)});\n`);
            if (helpers_1.isVoid(operation.type)) {
                this.write(`if (result) {
            return Result.error<ArrayBuffer>(result);
          }\n`);
            }
            else {
                this.write(`if (!result.isOk) {
            return Result.error<ArrayBuffer>(result.error()!);
          }\n`);
            }
        }
        if (!helpers_1.isVoid(operation.type)) {
            this.write(`const response = result.get();\n`);
        }
        if (helpers_1.isVoid(operation.type)) {
            this.visitWrapperBeforeReturn(context);
            this.write(`return Result.ok(new ArrayBuffer(0));\n`);
        }
        else if (helpers_1.isObject(operation.type)) {
            this.visitWrapperBeforeReturn(context);
            this.write(`return Result.ok(response.toBuffer());\n`);
        }
        else {
            this.write(`const sizer = new Sizer();\n`);
            this.write(helpers_1.size("response", operation.type, helpers_1.isReference(operation.annotations)));
            this.write(`const ua = new ArrayBuffer(sizer.length);
      const encoder = new Encoder(ua);
      ${helpers_1.encode("response", operation.type, helpers_1.isReference(operation.annotations))};\n`);
            this.visitWrapperBeforeReturn(context);
            this.write(`return Result.ok(ua);\n`);
        }
        this.write(`}\n\n`);
    }
    visitWrapperBeforeReturn(context) {
        this.triggerCallbacks(context, "WrapperBeforeReturn");
    }
}
exports.WrappersVisitor = WrappersVisitor;
//# sourceMappingURL=wrappers_visitor.js.map